import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["drops"][":id"]["activity"]["$get"]
>["param"]

export const getDropActivityQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["drops", "activity", queryInput],
  queryFn: async ({ pageParam }: { pageParam?: string }) => {
    const response = await apiClient.api.drops[":id"].activity.$get({
      param: queryInput,
      query: { cursor: pageParam },
    })

    if (!response.ok) throw await response.json()

    return response.json()
  },
  initialPageParam: undefined,
  getNextPageParam: (lastPage: { cursor?: string }) => {
    return lastPage.cursor
  },
})

type QueryFn = ReturnType<typeof getDropActivityQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
